/**
 * Converts a BE HTML snippet to plain text. Citation extracts can contain character references
 * (`&#10;`) and markup. Markup is removed before decoding, so `&lt;` ends up as a literal `<`.
 */
export const htmlToPlainText = (value: string): string => {
  if (!value) return value;

  // The only tags whose meaning is whitespace: without this they close up two lines
  // into one word.
  const withLineBreaks = value.replace(/<br\s*\/?>/gi, '\n').replace(/<\/(?:p|div|li|tr|h[1-6])\s*>/gi, '\n');

  // DOMParser builds an inert document: unlike innerHTML it runs no scripts and loads no
  // resources, so an extract carrying markup cannot have side effects.
  const text = new DOMParser().parseFromString(withLineBreaks, 'text/html').body.textContent ?? '';

  return text.replace(/\r\n?/g, '\n').trim();
};

/** Applies {@link htmlToPlainText} to every extract, so citations in app state are plain text. */
export const toPlainTextCitations = <T extends { extract: string }>(
  citations: Record<string, T> | undefined,
): Record<string, T> => {
  const plainText: Record<string, T> = {};
  for (const [id, citation] of Object.entries(citations ?? {})) {
    plainText[id] = { ...citation, extract: htmlToPlainText(citation.extract) };
  }
  return plainText;
};
